/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Menueditornotelabel3Inputs */

const en_menueditornotelabel3 = /** @type {(inputs: Menueditornotelabel3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Note for guests`)
};

const de_menueditornotelabel3 = /** @type {(inputs: Menueditornotelabel3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hinweis für Gäste`)
};

/**
* | output |
* | --- |
* | "Note for guests" |
*
* @param {Menueditornotelabel3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const menueditornotelabel3 = /** @type {((inputs?: Menueditornotelabel3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Menueditornotelabel3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_menueditornotelabel3(inputs)
	return de_menueditornotelabel3(inputs)
});
export { menueditornotelabel3 as "menuEditorNoteLabel" }